
export default {
  props: ['other'],
  data () {
    return {
      slide: 1
    }
  },
  methods: {
    toPage (url) {
      this.$router.push('/products/' + url)
    }
  }
}
